import { render, staticRenderFns } from "./series.vue?vue&type=template&id=1f2d4b0b&scoped=true&"
import script from "./series.vue?vue&type=script&lang=js&"
export * from "./series.vue?vue&type=script&lang=js&"
import style0 from "./series.vue?vue&type=style&index=0&id=1f2d4b0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2d4b0b",
  null
  
)

export default component.exports